import FlatButton from './FlatButton';

export default FlatButton;


// WEBPACK FOOTER //
// /src/components/UiComponents/FlatButton/index.js